import { ListingModeles } from '@components/listing-modeles/models';
import { videoMock } from '@mock/schema/components/shared';
import { Block } from '@shared/models';

export const listingModelesMock: Block<ListingModeles> = {
  type: 'listing-modeles',
  data: {
    items: [
      {
        text: `Chez SoCoo'c, 100% de nos meubles sont [[Made in France]]`,
        position: 4,
      },
      {
        video: videoMock(),
        position: 7,
      },
      {
        text: `Sur notre qualité zéro compromis, tous nos meubles sont [[garantis 10 ans]]`,
        position: 12,
      },
    ],
    fallbackSuggestions: `Aucun résultat ne correspond à votre recherche, mais ces modèles peuvent vous plaire :`,
    gtmConfigItems: {
      event: 'click_cta_visuel_cuisine',
      group: 'visuels cuisine',
      description: 'listing cuisines',
      context: 'clic visuel de fiche modele cuisine',
    },
  },
};
